/**
 * @param {String} token - JWT
 * @param {String} lang - locale en,fr
 * @returns {Object}
 */
export const generateHeaders = (lang, addLocale = false) => {
    const headers = {
        'Accept-Language': lang,
    };
    if (addLocale) {
        const shortenLang = lang.includes('-') ? lang.split('-')?.[0] : lang || 'en';
        headers.locale = shortenLang;
    }
    return headers;
};
